// Typelizer digest 6b03e0b9d54c665fa80f38b64634d0ec
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** DELETE /team/firms/:firm_id/engagement */
  destroy: (
    params: { firmId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/team/firms/:firm_id/engagement', params, options),
    method: 'delete',
  }),

  /** POST /team/firms/:firm_id/engagement */
  create: (
    params: { firmId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/team/firms/:firm_id/engagement', params, options),
    method: 'post',
  }),
}
